export class PurchaseOrderModel {
    customerContact: string;
    priceId: number;
    productId: number;
    orderCount: number;
    DiscountCode: string;
    IsRenewal: boolean;
    referralSource: string|null = 'null';
    tags:string=null;
}